<template>
  <div class="setting">
    <Header
      v-bind:pageName="pageName"
      v-bind:login="login"
      v-bind:profile="profile"
      @profile="profile = $event"
      v-bind:mai="mai"
      @mai="mai = $event"
    />
    <Loading v-if="loading" />
    <div v-else class="setting_wrapper">
      <section class="setting_profile">
        <h2>プロフィール設定</h2>
        <label class="icon"
          >アイコン
          <img
            class="icon-img"
            :src="
              !profile_data.icon.new
                ? profile_data.icon.old
                : profile_data.icon.new
            "
            alt="user-icon"
          />
          <input
            accept="image/jpeg,image/png,image/webp"
            type="file"
            @change="
              profile_data.save = true;
              iconUpload($event);
            "
          />
        </label>
        <label class="name">
          <p>
            ユーザーネーム<span
              class="error"
              v-if="profile_data.name.length <= 0"
              >※必須</span
            >
          </p>
          <span class="count">{{ profile_data.name.length }}/15</span>
          <input
            type="text"
            maxlength="15"
            v-model="profile_data.name"
            @input="
              profile_data.name.length
                ? (profile_data.save = true)
                : (profile_data.save = false)
            "
          />
        </label>
        <label class="profile">
          <p>プロフィール</p>
          <span class="count"
            >{{
              !profile_data.textarea ? profile_data.textarea.length : 0
            }}/200</span
          >
          <textarea
            maxlength="200"
            v-model="profile_data.textarea"
            @input="profile_data.save = true"
          ></textarea>
        </label>
        <div class="save">
          <button v-bind:disabled="!profile_data.save" @click="saveProfile()">
            変更を保存
          </button>
          <p class="message" :class="{ visible: profile_data.msg }">
            保存しました
          </p>
        </div>
      </section>
      <!-- <section class="setting_view">
        <h2>表示設定</h2>
      </section> -->
      <section class="setting_account">
        <h2>アカウント設定</h2>
        <p>外部サービス連携 |</p>
        <div class="link twitter" v-if="!loading">
          <p>
            <i class="fab fa-twitter"></i>Twitter<span v-if="provider.twitter"
              >連携中</span
            >
          </p>
          <button class="disable" v-if="provider.twitter && !provider.google">
            <p>連携解除不可</p>
            <i class="fas fa-minus"></i>
          </button>
          <button
            class="minus"
            v-else-if="provider.twitter"
            @click="
              popup_confirm.visible = !popup_confirm.visible;
              popup_confirm.provider = 'twitter';
            "
          >
            <p>連携解除</p>
            <i class="fas fa-minus"></i>
          </button>
          <button class="plus" @click="add_login('twitter')" v-else>
            <p>登録</p>
            <i class="fas fa-plus"></i>
          </button>
        </div>
        <div class="link google" v-if="!loading">
          <p>
            <i class="fab fa-google"></i>Google<span v-if="provider.google"
              >連携中</span
            >
          </p>
          <button class="disable" v-if="provider.google && !provider.twitter">
            <p>連携解除不可</p>
            <i class="fas fa-minus"></i>
          </button>
          <button
            class="minus"
            v-else-if="provider.google"
            @click="
              popup_confirm.visible = !popup_confirm.visible;
              popup_confirm.provider = 'google';
            "
          >
            <p>連携解除</p>
            <i class="fas fa-minus"></i>
          </button>
          <button class="plus" @click="add_login('google')" v-else>
            <p>登録</p>
            <i class="fas fa-plus"></i>
          </button>
        </div>
        <div class="popup_confirmation_wrapper" v-if="popup_confirm.visible">
          <div class="popup_confirmation">
            <p class="check">【注意】</p>
            <p>{{ popup_confirm.provider }}でログインできなくなります</p>
            <div class="btns">
              <button
                class="cancel"
                @click="popup_confirm.visible = !popup_confirm.visible"
              >
                キャンセル
              </button>
              <button
                class="submit"
                @click="unlink(`${popup_confirm.provider}.com`)"
              >
                確認
              </button>
            </div>
          </div>
        </div>
        <div class="logout_wrap">
          <p>ログアウト |</p>
          <button class="logout" @click="logout()">100maiからログアウト</button>
        </div>
      </section>
      <!-- <section class="setting_notice">
        <h2>通知設定</h2>
      </section> -->
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/modules/header";
import Loading from "@/components/parts/Loading";
import firebaseUtil from "@/firebase";
import store from "@/store";

export default {
  components: {
    Header,
    Loading,
  },
  data() {
    return {
      pageName: "設定",
      login: false,
      user: {},
      provider: {
        twitter: false,
        google: false,
      },
      profile: {},
      mai: {},
      loading: true,
      profile_data: {
        name: "",
        textarea: "",
        icon: {
          old: "",
          new: "",
        },
        save: false, //inputを受け取ったらtrueにする
        msg: false,
      },
      popup_confirm: {
        visible: false,
        provider: "",
      },
    };
  },
  created() {
    let myPromise1 = new Promise((resolve) => {
      firebaseUtil.onAuth("none").then(() => {
        resolve();
      });
    });
    myPromise1.then(() => {
      this.user = store.getters.user;
      if (!this.user.state) {
        this.user = "";
      } else {
        for (let i = 0; i < this.user.providerData.length; i++) {
          if (this.user.providerData[i].providerId == "twitter.com") {
            this.provider.twitter = true;
          } else {
            this.provider.google = true;
          }
        }
        this.login = true;
      }
    });
  },
  computed: {
    profileWatch() {
      return this.profile;
    },
  },
  watch: {
    profileWatch(data) {
      this.profile_data.name = data.name;
      this.profile_data.textarea = data.textarea;
      this.profile_data.icon.old = data.icon;
      this.loading = false;
      console.log(this.profile_data);
    },
  },
  methods: {
    add_login(provider) {
      firebaseUtil.addProvider(provider).then(() => {
        location.reload();
      });
    },
    unlink(provider) {
      firebaseUtil.unlink(provider).then(() => {
        location.reload();
      });
    },
    logout() {
      firebaseUtil.signOut().then(() => {
        location.reload();
      });
    },
    iconUpload(event) {
      const files = event.target.files || event.dataTransfer.files;
      const file = files[0];

      if (checkFile(file)) {
        getBase64(file).then((picture) => {
          this.profile_data.icon.new = picture;
        });
      }

      function checkFile(file) {
        let result = true;
        const SIZE_LIMIT = 5000000; // 5MB
        // ローカルマシンからの読み込みをキャンセルしたら処理中断
        if (!file) {
          result = false;
        }
        // jpeg か png 関連ファイル以外は受付けない
        if (
          file.type !== "image/jpeg" &&
          file.type !== "image/png" &&
          file.type !== "image/webp"
        ) {
          result = false;
        }
        // 上限サイズより大きければ受付けない
        if (file.size > SIZE_LIMIT) {
          result = false;
        }
        return result;
      }

      function getBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });
      }
    },
    saveProfile() {
      this.profile_data.msg = true;
      firebaseUtil.setUserProfile(this.user.uid, this.profile_data).then(() => {
        this.profile_data.save = false;
        setTimeout(() => {
          this.profile_data.msg = false;
        }, 2000);
      });
    },
  },
};
</script>

<style lang="scss">
.setting_wrapper {
  padding: 0px 4.6vw;
  text-align: left;
  h2 {
    @include fz(24);
    font-weight: 500;
    margin: 60px 0 20px;
  }
}
.setting {
  &_profile {
    label {
      @include fz(16);
      font-weight: 300;
    }
    .icon {
      @include icon(80px);
      background-color: #fff;
      position: relative;
      color: transparent;
      overflow: hidden;
      img.icon-img {
        border-radius: 50%;
        position: absolute;
        left: 0;
        top: 0;
        width: 80px;
        height: 80px;
        object-fit: cover;
      }
      input {
        /* 透明度0 */
        filter: alpha(opacity=0);
        -moz-opacity: 0;
        opacity: 0;
        /* ブラウザのデフォルトのスタイルを削除 */
        -webkit-appearance: none;
        appearance: none;
        /* レイアウトから無視 */
        position: absolute;
        height: 100%;
        width: 100%;
      }
      &::after {
        @include pseudo(100%, 100%);
        background-color: $fade_color;
        content: "\f030";
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
        color: #fff;
        @include fz(28);
        @include flex_c;
      }
    }
    .name,
    .profile {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      position: relative;
      span.error {
        color: red;
        @include fz(14);
      }
      span.count {
        position: absolute;
        right: 0;
        top: 0.5em;
      }
      input,
      textarea {
        margin-top: 4px;
        padding: 6px;
        background-color: #fff;
        border: 1px solid $text_gray;
        border-radius: 4px;
      }
    }
    .profile {
      textarea {
        min-height: 120px;
      }
    }
    .save {
      margin-top: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      button {
        @include round_btn($main_orange, #fff, "none");
        box-shadow: $btn_shadow;
        @include zIndex(1);
        &:disabled {
          background-color: $text_gray;
        }
      }
      p {
        margin-left: 10px;
        @include fz(14);
        line-height: 1;
      }
      .message {
        height: 32px;
        padding: 0 20px;
        margin-left: 20px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #000;
        opacity: 0;
        transform: translateX(-100%);
        transition: 0.3s;
        &::after {
          @include pseudo(1px, 24px);
          background-color: #000;
          bottom: 10px;
          left: -18px;
          transform: rotate(60deg);
        }
        &.visible {
          opacity: 1;
          transform: translateX(0);
        }
      }
    }
  }
  &_account {
    .link {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 20px 0;
      background-color: #fff;
      height: 40px;
      padding: 0 20px;
      border-radius: 4px;
      box-shadow: $btn_shadow;
      p {
        display: flex;
        align-items: center;
        margin-right: 40px;
        > i {
          @include fz(18);
          &.fa-twitter {
            color: $twitter;
          }
          &.fa-google {
            color: $google;
          }
          margin-right: 10px;
        }
        span {
          margin-left: 10px;
          background-color: $main_orange;
          color: #fff;
          font-weight: 500;
          border-radius: 15px;
          height: 30px;
          padding: 0 10px;
          @include flex_c;
          @include fz(14);
          line-height: 1;
        }
      }
      button {
        @include icon(32px);
        background-color: $bg_accent;
        color: #fff;
        > i {
          @include fz(18);
        }
        p {
          position: absolute;
          opacity: 0;
        }
        &.plus {
          @include default_button("scale");
        }
        &.minus {
          @include invert_button("scale", $text_gray);
        }
      }
    }
    .logout {
      &_wrap {
        margin-top: 40px;
      }
      margin: 20px 0;
      @include fz(18);
      @include flex_c;
      padding: 4px 10px;
      height: 40px;
      border-radius: 20px;
      background-color: #fff;
      color: $main_orange;
      border: 2px solid $main_orange;
      transition: 0.3s;
      @include pc {
        &:hover {
          background-color: $main_orange;
          color: #fff;
        }
      }
    }
  }
  .popup_confirmation {
    @include popup();
    display: flex;
    flex-direction: column;
    align-items: center;
    p {
      display: inline-block;
      font-weight: 500;
    }
    .check {
      color: $red;
    }
    .btns {
      margin-top: 40px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      button {
        @include flex_c();
        width: 46%;
        background-color: $bg_accent;
        font-weight: 500;
        @include fz(16);
        height: 40px;
        border-radius: 20px;
        &.submit {
          background-color: $main_orange;
          color: #fff;
        }
      }
    }
  }
}
</style>
